// extracted by mini-css-extract-plugin
export default {"header":"Page404_header__8wcbO"};